import { IssueReorderableAdminEntityPermittedAction } from "./IssueAdminEntity";

export enum IssueCustomAttributeMappingType {
  Project = "project",
  IssueTypeCategory = "issueTypeCategory",
  IssueType = "issueType",
}

export enum V2IssueCustomAttributeMappingServerType {
  Project = "container",
  IssueTypeCategory = "issueType",
  IssueType = "issueSubtype",
}

export type IssueCustomAttributeMappingPermittedAttribute = "isRequired";

export interface IssueCustomAttributeMapping {
  id: string;
  attributeDefinitionId: string;
  mappedItemType: IssueCustomAttributeMappingType;
  mappedItemId: string;
  order?: number;
  isRequired: boolean;
  permittedActions: IssueReorderableAdminEntityPermittedAction[];
  permittedAttributes: "isRequired"[];
}

export interface IssueCustomAttributeMappingAttributes {
  attributeDefinitionId: string;
  mappedItemId: string;
  mappedItemType: IssueCustomAttributeMappingType;
  isRequired?: boolean;
}

export interface IssueCustomAttributeMappingsBatchPayload {
  mappedItemId: string;
  mappedItemType: IssueCustomAttributeMappingType;
  attributeDefinitions: {
    attributeDefinitionId: string;
    isRequired: boolean;
  }[];
}
